import React from 'react';
import clsx from 'clsx';
import CheckmarkIcon from './assets/icons/checkmark.svg?react';
import './CircularSelector.scss';

interface CircularSelectorProps {
  selected: boolean;
  onClicked: () => void;
}

export const CircularSelector = ({
  selected,
  onClicked,
}: CircularSelectorProps) => {
  const circleClass = clsx(
    'agxCircularSelector-circle',
    selected && 'selected'
  );

  const onSelectorClicked = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    onClicked();
  };

  return (
    <div className="agxCircularSelector" onClick={onSelectorClicked}>
      <div className={circleClass}>
        {selected && <CheckmarkIcon className="agx-circularSelector-icon" />}
      </div>
    </div>
  );
};
